import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
import { BaseButton } from '../button';
import { Icon } from '../icon';
import { ArrowIcon } from '../icons';
import { Typography } from '../typography';
import { useAccordion } from './hooks';
/**
 * Компонент `<Accordion />` служит для отображения вертикального списка пунктов, каждый из них можно раскрыть и увидеть содержимое.
 */
export const Accordion = ({
  title,
  children,
  onClick,
  className,
  size = 'm',
  stroke = true,
  defaultClosed = true,
  leftElement,
  rightElement,
  'data-testid': testId = 'accordion'
}) => {
  const {
    open,
    bodyRef,
    contentRef,
    leftElemRef,
    leftElemWidth,
    handleClick
  } = useAccordion({
    defaultClosed,
    onClick
  });
  const accordionClassNames = useMemo(() => clsx(styles.accordion, styles[size], stroke ? styles.stroke : styles.unstroke, open && styles.opened, className), [size, stroke, open, className]);
  // const testId = props['data-testid'] || 'accordion';
  const isStringTitle = typeof title === 'string';
  const Title = () => {
    if (!isStringTitle) {
      return title;
    }
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "m",
      size: "body_accent"
    }, title);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: accordionClassNames,
    "aria-expanded": open,
    "aria-controls": "panel",
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(BaseButton, {
    className: styles.heading,
    onClick: handleClick,
    "data-testid": `${testId}--heading`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.headingGroup
  }, leftElement && (/*#__PURE__*/React.createElement("div", {
    ref: leftElemRef,
    "data-testid": `${testId}--heading-left`
  }, leftElement)), /*#__PURE__*/React.createElement(Title, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.headingGroup
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": `${testId}--heading-right`
  }, rightElement), /*#__PURE__*/React.createElement(Icon, {
    size: "space-250",
    color: "text-primary",
    "aria-label": open ? `ui.accordion.hide ${title}` : `ui.accordion.show ${title}`,
    className: clsx(styles.chevron)
  }, /*#__PURE__*/React.createElement(ArrowIcon, null)))), /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrapper,
    ref: bodyRef,
    "data-testid": `${testId}--body`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    style: {
      paddingLeft: leftElemWidth
    },
    ref: contentRef,
    "data-testid": `${testId}--body-content`
  }, children)));
};